import { getRegion } from 'utils/Region';
import { EXCLUDED_PATHS, LOADER_ACTIVE_REGION } from './constants';

export const isPathnameExcluded = pathname =>
    EXCLUDED_PATHS.some(item => pathname?.includes(item.path));

export const isLoaderEnabled = loaderMetardaConfig => {
  // Wokaround temporal ya que de momento (Enero 2026) no es posible cargar la llave,
  // Por definicion de negocio, se usara la region activa como fuente de verdad en este workaround.
  const isLoaderEnabledByRegion = getRegion() === LOADER_ACTIVE_REGION;
  const isLoaderConfigValid =
    loaderMetardaConfig?.enable !== undefined && loaderConfig?.enable !== null;

  return  isLoaderConfigValid ? loaderConfig.enable : isLoaderEnabledByRegion;
}

export const hasDeviceModelParam = search => 
  new URLSearchParams(search).has('device_model');
